module.exports = __webpack_public_path__ + "img/B275.407852a9.png";